// This class transforms the configuration from nuskin.configuration to the configuration used by meCommerce.
var ConfigAdaptor = function(legacyConfig) {
    // For all environments other than test, stage, and production we want to set the serviceDomain to https://test.nuskin.com, otherwise we take the host of the url
    var serviceDomain = (window.location.href.indexOf('localhost') > -1
    || window.location.host.indexOf('8080') > -1
    || window.location.host.indexOf('dev') > -1) ? 'https://test.nuskin.com' : 'https://' + window.location.host;

    // For all environments other than dev, test, stage, and production we want to set the contentDomain to https://test.nuskin.com, otherwise we take the host of the url
    var contentDomain = (window.location.href.indexOf('localhost') > -1
    || window.location.host.indexOf('8080') > -1) ? 'https://test.nuskin.com' : 'https://' + window.location.host;

    var config = {
        site: {
            services: {},
            regions: {}
        },
        system: {
            mulesoft: {}
        },
        languageCode: getLanguage()
    };

    setSiteConfig(legacyConfig);
    setSystemConfig(legacyConfig);

    // -----------------------------------------------------
    //
    //                 Private Methods
    //
    // -----------------------------------------------------
    /**
     *
     * @param {Object} legacyConfig
     */
    function setSiteConfig(legacyConfig) {
        if (legacyConfig) {
            if (legacyConfig.mecSite) {
                // todo At some point we will want to throw this away.
                config.site.meServer = legacyConfig.mecSite.meServer;
                config.site.countryCode = nuskin ? nuskin.configuration.markets: getCountry();

                // Some config for account
                config.site.otherOptionHide = legacyConfig.mecSite.otherOptionHide;
                config.site.hideDirectDeposit = legacyConfig.mecSite.hideDirectDeposit;
                config.site.hasBusinessTaxIdTooltip = legacyConfig.mecSite.hasBusinessTaxIdTooltip;
                config.site.businessTaxIdMaxLength = legacyConfig.mecSite.businessTaxIdMaxLength;
                config.site.isBussDistEnabled = legacyConfig.mecSite.isBussDistEnabled;
                config.site.isOpted = legacyConfig.mecSite.isOpted;
                config.site.emailIsOpted = legacyConfig.mecSite.emailIsOpted;
                config.site.textIsOpted = legacyConfig.mecSite.textIsOpted;
                config.site.defaultShowContactInfo = legacyConfig.mecSite.defaultShowContactInfo;
                config.site.defaultShowContactInfoToFirstUpLine = legacyConfig.mecSite
                    .defaultShowContactInfoToFirstUpLine;
                config.site.defaultShowContactInfoToFamilyAndFriends = legacyConfig.mecSite
                    .defaultShowContactInfoToFamilyAndFriends;
                config.site.minAge = legacyConfig.mecSite.minAge;
                config.site.termsOfUse = '{termsOfUse}';
                config.site.privacyPolicy = '{privacyPolicy}';

                config.site.enableEveryOneOption = legacyConfig.mecSite.enableEveryOneOption;
                config.site.enableFamilyOption = legacyConfig.mecSite.enableFamilyOption;
                config.site.enableSponsorOption = legacyConfig.mecSite.enableSponsorOption;
                config.site.enableUplineOption = legacyConfig.mecSite.enableUplineOption;
                config.site.enableScannerOption = legacyConfig.mecSite.enableScannerOption;
                config.site.hasDirectDepositPolicy = legacyConfig.mecSite.hasDirectDepositPolicy;
                config.site.enableFamilySection = legacyConfig.mecSite.enableFamilySection;

                // Some config for Signin
                config.site.isGuestCheckoutEnabled = legacyConfig.mecSite.isGuestCheckoutEnabled;
                config.site.mecEnableSignupMarketList = legacyConfig.mecSite.mecEnableSignupMarketList;

                // Some config for Signup
                config.site.hideCustomerSignup = legacyConfig.mecSite.hideCustomerSignup;

                config.site.services.invitation_endpoint = serviceDomain + '/invitation/api/v1/invitation/';
                config.site.services.invitation_endpoint_new = serviceDomain + '/invitation/api/v2/invitation/';
            }

            config.site.legacyServer = legacyConfig.siteUrl;
        }
        // todo We need to get the languages for a particular market using a service. Do we need this config?
        config.site.languages = ['en'];

        config.site.signInForgotPasswordPagePath = '#forgot-password';
        config.site.forgotUserNamePath = '#forgot-username';
        config.site.dateMask = 'L';

        config.site.passwordShowImage = contentDomain + '/content/dam/signinNew/ic-password-show.png';
        config.site.passwordHideImage = contentDomain + '/content/dam/signinNew/ic-password-hide.png';

        // terms and conditions page
        config.site.TandCversionNumber = '121233';
        config.site.distributorCompensationPath = contentDomain + '/content/dam/mecommerce/termsandconditions';
        config.site.productPolicyPath = contentDomain + '/content/dam/mecommerce/termsandconditions';
        config.site.termsandconditionscontentpath = contentDomain + '/content/dam/mecommerce/termsandconditions';

        // Some config for Signup
        config.site.linkUrl = '#/signup-create-user';
        config.site.sponsorsearchpath = '#/search-distributor';
        config.site.distributorRedirect = '#/distributor-setup';
        config.site.associateRedirect = '#/distributorsignup-minimal';

        // distributorSetup page
        config.site.signupPagePath = '#/distributorsignup-minimal';

        // distributorsignup-minimal page
        config.site.emeadistributorpathaddress = '#/distributorsignup-address';
        config.site.tcpath = '#/distributorsignup-optional';
        config.site.distributorpathsignmin = '#/distributorsignup-optional';
        config.site.associatepathsignmin = '#/distributorsignup-optional';
        config.site.date= 'MDY';
        config.site.dateFormat = 'MDY';
        config.site.minAge = '18';
        config.site.regions.emea = nuskin ? nuskin.configuration.mecSite.mecEnableSignupMarketList : '';

        // distributorsignup-optional page
        config.site.hasBusinessTaxIdTooltip = false;

        // review-signup-info page
        config.site.tncPagePath = '#/terms-and-conditions';

        // termsandconditions page
        config.site.distributorCompensationPath = contentDomain + '/content/dam/mecommerce/termsandconditions';
        config.site.productPolicyPath = contentDomain + '/content/dam/mecommerce/termsandconditions';
        config.site.termsandconditionscontentpath = contentDomain + '/content/dam/mecommerce/termsandconditions';

        config.site.otherOptionHide = false;

        config.site.termsAndUseContentPath = contentDomain + '/content/dam/account/' + getCountry() + '/Terms-of-Use_' + getLanguage() + '.html';
        config.site.privacyPolicyContentPath = contentDomain + '/content/dam/account/' + getCountry() + '/Privacy-Policy_' + getLanguage() + '.html';

        config.site.defaultProfileImgUrl = contentDomain + '/content/dam/account/profile-name-hover.png';

        // distributorSetup page
        config.site.distributorSetupImage = contentDomain + '/content/dam/mecommerce/signup/landing-pages/' +
            'productLandingPage42.png';
        config.site.clockImg = contentDomain + '/content/dam/account/clock.svg';

        // distributor-authenticatd-suggestions
        config.site.prospectingImagePath = contentDomain + '/content/dam/account/prospecting.svg';
        config.site.mediaCentreImagePath = contentDomain + '/content/dam/account/media-centre.svg';
        config.site.myStoreImagePath = contentDomain + '/content/dam/account/my-store.svg';
        config.site.trainingImagePath = contentDomain + '/content/dam/account/training.svg';
        config.site.orderImagePath = contentDomain + '/content/dam/account/order.svg';
        config.site.accountSettingImagePath = contentDomain + '/content/dam/account/ic-profile.svg';
        config.site.mbsImagePath = contentDomain + '/content/dam/account/mbs-share.png';

        // Paths - todo the paths below that have /content/mecommerce in the path need to be deleted. They don't exist on nuskin.com.
        config.site.nvgaccsettpath = contentDomain + '/content/mecommerce/' + getLocale() + '/profile/personal.html';
        config.site.nvgprospectpath = contentDomain + '/content/mecommerce/' + getLocale() + '/prospecting.html';
        config.site.nvgtrainingpath = '';
        config.site.nvgmediacenterpath = contentDomain + '/content/mecommerce/' + getLocale() + '/media-center/dashboard.html';
        config.site.nvgorderspath = '';
        config.site.nvgmystorepath = '';
        config.site.nvgmbsstorypath = contentDomain + '/content/mecommerce/' + getLocale() + '/my-story/ms-story-script.html';
        config.site.nvgmbsOverviewPath = contentDomain + '/content/mecommerce/' + getLocale() + '/my-story/ms-overview.html';

        // cust-inddist-conversion-review page
        config.site.cdcrnextbutpath = '#/terms-and-conditions';

        // distributor-invite-type page
        config.site.inviteLinkPagePath = '#/distributor-invite-link';
        config.site.businessPagePath = contentDomain + '/content';
        config.site.distributorInviteType = '#/distributor-invite-type';
        config.site.distributorInviteCountryPreference = '#/distributor-invite-market-preference';
        // todo hook this up to a service.
        config.site.getCountyLanguageList = '/bin/countryAndLanguageTranslation.' + nuskin.util.languageCode;
        // todo hook this up to a service.
        config.site.getCountryAndLanguageTranslation = contentDomain + '/bin/mecommerce/countryAndLanguageTranslation';
        config.site.signupPagePathfromInvite = '#/signup-create-user';

        // user-profile-header page
        config.site.checkmarkCircle = contentDomain + '/content/dam/account/checkmark-circle.svg';
        config.site.avatarImg = contentDomain + '/content/dam/account/generic_photo.png';

        config.site.showPoundLimitText = nuskin.configuration.showPoundLimitText;
        config.site.showBusinessInfo = nuskin.configuration.showBusinessInfo;
        config.site.showAddress = nuskin.configuration.showAddress;

        config.site.defaultProfileImagePath = contentDomain + '/content/dam/account/profile-name-hover.png';
    }

    /**
     * Gets the system configs from the legacy configs
     * @param {Object} legacyConfig
     */
    function setSystemConfig(legacyConfig) {
        if (legacyConfig) {
            if (legacyConfig.mecSite) {
                config.system.googlePlacesOnOffFlag = legacyConfig.mecSite.googlePlacesOnOffFlag;
                config.system['mulesoft.storefront_endpoint'] = legacyConfig.mulesoftStorefrontEndpoint;
                config.system['mulesoft.token_endpoint'] = legacyConfig.mulesoftTokenEndpoint;

                config.system.qas_service_url = contentDomain + '/signupApp/qas/prowebproxy.jsp';
                config.system.s3_bucket_url = legacyConfig.s3BucketUrl;

                // Get the test client_id working for all the services we call. Dennis Bell can do this.
                // Then use legacyConfig.checkout.clientId.
                config.system.mulesoft.client_id = nuskin.configuration.checkout.clientId;
                // Get the test client_secret working for all the services we call. Dennis Bell can do this.
                // Then use legacyConfig.checkout.clientSecret.
                config.system.mulesoft.client_secret = nuskin.configuration.checkout.clientSecret;
                // Get the test client_id working for all the services we call. Dennis Bell can do this.
                // Then use legacyConfig.checkout.clientId.
                config.system['mulesoft.client_id'] = nuskin.configuration.checkout.clientId;
                // Get the test client_secret working for all the services we call. Dennis Bell can do this.
                // Then use legacyConfig.checkout.clientSecret.
                config.system['mulesoft.client_secret'] = nuskin.configuration.checkout.clientSecret;

                config.system.shortenURL_service_url = 'https://po.st/api/shorten';
                config.system.shortenURL_service_key = '7EF55583-5D0E-409F-9789-4FD18D7A4A90';

                // New Service related configs
                config.system['services.service_endpoint'] = serviceDomain + '/account-util/api';
                config.system['services.sponsor_search_query'] = '/v1/person/simple';
                config.system['services.sponsor_search_distributor_query_key'] = 'sapID=';
                config.system['services.sponsor_search_email_query_key'] = 'email=';
                config.system['services.sponsor_search_phone_query_key'] = 'phone=';
                config.system['services.sponsor_search_first_name_query_key'] = 'firstName=';
                config.system['services.sponsor_search_last_name_query_key'] = 'lastName=';
                config.system['services.getservice_query'] = serviceDomain + '/mec';
            }

            config.system.apiKey = legacyConfig.gigyaApiKey;
            config.system.googlePlacesApiServerKey = legacyConfig.googleMapsApiKey;

            // AWS Stuff
            config.system.useAwsAuthorizeService = legacyConfig.useAwsAuthorizeService;
            config.system.awsUrl = legacyConfig.awsUrl;

            // Todo Refactor code to not use this.
            config.system.mulesoft.hybris_endpoint = 'Should not be used';
            config.system.mulesoft.hybris_guest_endpoint = 'Should not be used';
            config.system['mulesoft.hybris_endpoint'] = 'Should not be used';
            config.system['mulesoft.hybris_guest_endpoint'] = 'Should not be used';
        }

        config.system.atlas_service_url = serviceDomain + '/eft-service/api/v2/';
    }

    /**
     * Gets countryCode from the url
     * @return {string}
     */
    function getCountry() {
        // todo get the country from the locale in the url.
        return legacyConfig.mecSite ? legacyConfig.mecSite.countryCode : 'US';
    }

    /**
     * Gets language from the url
     * @return {string}
     */
    function getLanguage() {
        // todo get the language from the locale in the url.
        return 'en';
    }

    /**
     * Gets locale from the url
     * @return {string}
     */
    function getLocale() {
        // todo get the locale from the locale in the url.
        return getLanguage() + '_' + getCountry();
    }

    return config;
};

export default ConfigAdaptor;



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/src/util/config-manager/configAdapter.js
// module id = 231
// module chunks = 0